export default __webpack_public_path__ + "static/media/assistant_doctor_avatar.2741f53e.png";